import { GenericResponse } from 'services/api/base';
import {
  IntersemanalVisaoGeral,
  IntersemanalChuva,
  IntersemanalCarga,
  IntersemanalResultados,
  IntersemanalPremissas,
} from 'types/Relatorios/Intersemanal';

export const transformIntersemanalVisaoGeralResponse = (
  response: GenericResponse<IntersemanalVisaoGeral>,
): IntersemanalVisaoGeral => response.data;

export const transformIntersemanalChuvaResponse = (
  response: GenericResponse<IntersemanalChuva>,
): IntersemanalChuva => response.data;

export const transformIntersemanalCargaResponse = (
  response: GenericResponse<IntersemanalCarga>,
): IntersemanalCarga => response.data;

export const transformIntersemanalResultadosResponse = (
  response: GenericResponse<IntersemanalResultados>,
): IntersemanalResultados => response.data;

export const transformIntersemanalPremissasResponse = (
  response: GenericResponse<IntersemanalPremissas>,
): IntersemanalPremissas => response.data;
